<template>
  <div class="data-table">
    <div class="head">
      <div class="head-action">
        <a-button type="primary" @click="edit(0)">新增</a-button>
        <a-button type="primary" @click="disabled">{{
          selectRowData.Status == 1 ? "禁用" : "启用"
        }}</a-button>
      </div>
      <div class="head-search">
        <div class="head-search-box" style="width:290px;">
          <div class="head-search-button">
            <a-form :form="option.headSearchForm" layout="inline">
              <a-form-item>
                <a-input
                  v-model="searchForm.KeyWord"
                  placeholder="请输入名称/代码"
                  @pressEnter="search"
                />
              </a-form-item>
              <a-form-item>
                <a-button type="primary" @click="search">查询</a-button>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </div>
    </div>
    <dataGrid
      ref="dataGrid"
      v-model="data"
      :params="option.params"
      :columns="option.columns"
      :pagination="true"
      :url="url.MemberCardType"
      @selectRow="selectRow"
      @update="gridUpdate"
      bordered
    >
    </dataGrid>
    <Edit ref="Edit" @submit="updateGrid"></Edit>
  </div>
</template>

<script>
import { cache } from "@/utils/common.js";
import dataGrid from "@/components/dataGrid/DataGrid";
// import dataForm from "@/components/dataForm/DataForm";
import Edit from "@/views/groupMember/type/Edit";
export default {
  name: "CustomerManage",
  components: {
    Edit,
    dataGrid
    // dataForm
  },
  data() {
    return {
      //选中行
      selectRowData: {},
      searchForm: {
        KeyWord: ""
      },
      modal1Visible: false,
      data: [],
      option: {
        params: {},
        headSearchForm: this.$form.createForm(this),
        headSearch: {
          colnum: 1,
          content: [
            {
              label: null,
              placeholder: "请输入代码",
              name: "Name"
            }
          ]
        },
        columns: [
          {
            title: "序号",
            width: "50px", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "状态",
            width: 80,
            customRender: (text, record) => {
              return <div>{record.Status == 1 ? "启用" : "禁用"}</div>;
            }
          },
          {
            title: "代码",
            width: 150,
            dataIndex: "Code"
          },
          {
            title: "名称",
            width: 150,
            dataIndex: "Name"
          },
          {
            title: "有效期开始时间",
            width: 140,
            dataIndex: "StartTime"
          },
          {
            title: "有效期结束时间",
            width: 140,
            dataIndex: "EndTime"
          },
          {
            title: "退房时间",
            width: 100,
            dataIndex: "CheckoutTime"
          },
          // {
          //   title: "销售价格",
          //   width: 100,
          //   align: "right",
          //   dataIndex: "SalePrice"
          // },
          // {
          //   title: "续卡金额",
          //   width: 100,
          //   align: "right",
          //   dataIndex: "ContinueCard"
          // },
          // {
          //   title: "余额小于提醒",
          //   width: 160,
          //   align: "right",
          //   dataIndex: "RemindBalance"
          // },
          // {
          //   title: "赠送积分",
          //   width: 100,
          //   align: "right",
          //   dataIndex: "PresentPoint"
          // },
          {
            title: "操作",
            width: 160,
            align: "center",
            customRender: (text, record) => {
              return (
                <div>
                  <a-button
                    size="small"
                    type="link"
                    {...{
                      on: {
                        click: this.edit.bind(null, 1, record)
                      }
                    }}
                  >
                    编辑
                  </a-button>
                  <div class="ant-divider ant-divider-vertical" />
                  <a-button
                    size="small"
                    type="link"
                    {...{
                      on: {
                        click: this.edit.bind(null, 2, record)
                      }
                    }}
                  >
                    查看
                  </a-button>
                </div>
              );
            }
          }
        ]
      }
    };
  },
  created() {
    this.user = cache.get("user");
    var url = {
      MemberCardType: "MemberCardType",
      MemberDisabledCardType: "MemberDisabledCardType"
    };
    if (this.user.IsGroupSystem) {
      for (let i in url) {
        url[i] = "Group" + url[i];
      }
    }
    this.url = url;
  },
  methods: {
    search() {
      this.option.params = {
        KeyWord: this.searchForm.KeyWord
      };
    },
    edit(type, row) {
      if (type == 0) {
        row = this.$refs.dataGrid.getSelected();
      }
      if (!row && type > 0) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      this.$refs.Edit.show(type, row.Id);
    },
    cost() {},
    integral() {},
    disabled() {
      let row = this.$refs.dataGrid.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      this.$post(this.url.MemberDisabledCardType, {
        Id: row.Id
      }).then(res => {
        if (res.Data) {
          this.updateGrid();
        }
      });
    },
    updateGrid() {
      this.$refs.dataGrid.reload();
    },
    gridUpdate() {
      this.selectRowData = {};
    },
    selectRow(row) {
      this.selectRowData = row;
    }
  }
};
</script>

<style lang="less" scoped>
.data-table {
  position: relative;
  overflow: hidden;
  min-height: calc(100vh - 200px);
}

.data-table .head {
  display: flex;
}

.data-table .head .head-action {
  margin-bottom: 10px;
  margin-top: 5px;
}

.data-table .head .head-search {
  text-align: right;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.data-table .head .head-search-box .head-search-button {
  margin-left: 16px;
  margin-top: 3px;
}

.data-table .head .head-search-box {
  display: flex;
  float: right;
  text-align: left;
}

.ant-btn + .ant-btn {
  margin-left: 10px;
}
</style>
